import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './contexts/AuthContext'
import { PostHogProvider } from './components/PostHogProvider'
import { PrivateRoute } from './components/PrivateRoute'
import { PrivateRouteNoLayout } from './components/PrivateRouteNoLayout'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import Onboarding from './pages/Onboarding'
import Llms from './pages/Llms.tsx'
import Settings from './pages/Settings'
import AddBrand from './pages/AddBrand'
import ContentManager from './pages/ContentManager'
import Search from './pages/SearchQueries.tsx'
import Competition from './pages/Competition.tsx'
import SearchIntelligence from './pages/SearchIntelligence.tsx'
import MarketIntelligence from './pages/MarketIntelligence.tsx'
import Contact from './pages/Contact'
import Admin from './pages/Admin'
import BlogList from './pages/BlogList'
import BlogPost from './pages/BlogPost'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Debug component to log all navigation changes
function NavigationLogger() {
  const location = useLocation()

  useEffect(() => {
    console.log('🔄 [Navigation] Changed to:', {
      pathname: location.pathname,
      search: location.search,
      fullUrl: window.location.href,
      timestamp: new Date().toISOString()
    })
  }, [location])

  return null
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <PostHogProvider>
        <NavigationLogger />
        <AuthProvider>
          <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Blog routes - public, no auth required */}
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          {/* Demo routes - completely public, no auth required */}
          <Route path="/demo" element={<Navigate to="/dashboard?demo=true" replace />} />
          <Route path="/dashboard" element={<PrivateRoute />}>
            <Route index element={<Dashboard />} />
          </Route>
          <Route path="/search" element={<PrivateRoute />}>
            <Route index element={<SearchIntelligence />} />
          </Route>
          <Route path="/market" element={<PrivateRoute />}>
            <Route index element={<MarketIntelligence />} />
          </Route>
          <Route path="/competition" element={<PrivateRoute />}>
            <Route index element={<Competition />} />
          </Route>
          <Route path="/llms" element={<PrivateRoute />}>
            <Route index element={<Llms />} />
          </Route>
          <Route path="/content" element={<PrivateRoute />}>
            <Route index element={<ContentManager />} />
          </Route>
          <Route path="/search-queries" element={<PrivateRoute />}>
            <Route index element={<Search />} />
          </Route>

          {/* Onboarding route - no sidebar */}
          <Route element={<PrivateRouteNoLayout />}>
            <Route path="/onboarding" element={<Onboarding />} />
          </Route>

          {/* Protected routes that require authentication (unless demo mode) */}
          <Route path="/settings" element={<PrivateRoute />}>
            <Route index element={<Settings />} />
          </Route>
          <Route path="/settings/brands" element={<PrivateRoute />}>
            <Route index element={<Settings />} />
          </Route>
          <Route path="/settings/profile" element={<PrivateRoute />}>
            <Route index element={<Settings />} />
          </Route>
          <Route path="/settings/billing" element={<PrivateRoute />}>
            <Route index element={<Settings />} />
          </Route>
          <Route path="/contact" element={<PrivateRoute />}>
            <Route index element={<Contact />} />
          </Route>
          <Route path="/add-brand" element={<PrivateRoute />}>
            <Route index element={<AddBrand />} />
          </Route>
          <Route path="/admin" element={<PrivateRoute />}>
            <Route index element={<Admin />} />
          </Route>
        </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </AuthProvider>
      </PostHogProvider>
      </Router>
    </HelmetProvider>
  )
}

export default App